var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEarly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 39,
    viewBox: "0 0 41 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 39,
    rx: 8,
    fill: "#00BA34",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2352 9.17593C22.1158 8.60802 19.8842 8.60802 17.7648 9.17593C17.0979 9.3546 16.4125 8.95888 16.2338 8.29204C16.0552 7.62521 16.4509 6.93979 17.1177 6.76111C19.661 6.07963 22.339 6.07963 24.8823 6.76111C25.5491 6.93979 25.9448 7.62521 25.7662 8.29204C25.5875 8.95888 24.9021 9.3546 24.2352 9.17593ZM28.32 9.5435C28.7375 8.99369 29.5217 8.88645 30.0715 9.30395C31.6605 10.5106 32.9928 12.0221 33.9904 13.75C34.3356 14.3479 34.1307 15.1124 33.5328 15.4575C32.935 15.8027 32.1705 15.5979 31.8253 15C30.994 13.5601 29.8837 12.3005 28.5596 11.295C28.0098 10.8775 27.9025 10.0933 28.32 9.5435ZM21 12.5C16.1675 12.5 12.25 16.4175 12.25 21.25C12.25 26.0825 16.1675 30 21 30C25.8325 30 29.75 26.0825 29.75 21.25C29.75 16.4175 25.8325 12.5 21 12.5ZM9.75 21.25C9.75 15.0368 14.7868 10 21 10C27.2132 10 32.25 15.0368 32.25 21.25C32.25 27.4632 27.2132 32.5 21 32.5C14.7868 32.5 9.75 27.4632 9.75 21.25ZM26.8839 17.2411C27.372 17.7293 27.372 18.5207 26.8839 19.0089L20.6339 25.2589C20.1457 25.747 19.3543 25.747 18.8661 25.2589L15.7411 22.1339C15.253 21.6457 15.253 20.8543 15.7411 20.3661C16.2293 19.878 17.0207 19.878 17.5089 20.3661L19.75 22.6072L25.1161 17.2411C25.6043 16.753 26.3957 16.753 26.8839 17.2411Z",
    fill: "#00BA34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarly);
export default __webpack_public_path__ + "static/media/early.cdba9b9e498f54f290bbb9d7ae8d5b23.svg";
export { ForwardRef as ReactComponent };